import * as R from "ramda";
import { CommonRectangle } from "@/stencils/utils/commonShape";
import { SVG } from "@svgdotjs/svg.js";

const stencilName = "不等于";
const icon = require("./icon.svg");

const shape = CommonRectangle.define(
  "stencil.notEqual",
  {},
  {
    operator: "!=",
    outputType: "boolean",
    stencilName,
    stencilType: "notEqual",
    labelGroupImageAttrs: {
      width: 24,
      height: 24,
      "xlink:href": icon,
    },
  }
);

const svg = (() => {
  const draw = SVG().size(32, 32);
  draw
    .rect(32, 32)
    .attr({ fill: "#010016", stroke: "rgba(41, 54, 70, 1)", strokeWidth: 1 });
  draw.image(icon).size(24, 24).move(4, 4);
  return draw.svg();
})();

const initData = {};

const createCell = (position) => {
  const cell = shape
    .create({
      data: R.clone(initData),
      size: { width: 32, height: 32 },
      ports: { in: 2, out: 1, maxOutLinkNumber: -1 },
    })
    .position(position.x, position.y);

  return cell;
};

const reloadCell = (cellJson) => {
  const cell = shape.reloadCell({
    cellJson,
    initData: R.clone(initData),
    ports: { maxOutLinkNumber: -1 },
  });

  return cell;
};

export default {
  createCell,
  reloadCell,
  icon,
  svg,
  group: "ComparisonSymbols",
  stencilName,
  sortNo: 8,
};
